import type { Json } from '@/integrations/supabase/types';
import type { ServicoOS, EnderecoOS } from '@/types/ordemServico';

export function parseServicos(servicos: Json): ServicoOS[] {
  if (!servicos) return [];
  if (Array.isArray(servicos)) {
    return servicos.map((s: Record<string, unknown>) => {
      const tipo = typeof s.tipo === 'string' ? s.tipo : '';
      const valor = typeof s.valor === 'number' ? s.valor : 0;
      const descricao = typeof s.descricao === 'string' && s.descricao
        ? s.descricao
        : (tipo && !tipo.match(/^[a-f0-9-]{36}$/i) ? tipo : '');
      return { tipo, valor, descricao };
    });
  }
  return [];
}

export function parseEndereco(endereco: Json): EnderecoOS {
  if (!endereco || typeof endereco !== 'object' || Array.isArray(endereco)) {
    return { rua: '', numero: '', cidade: '', codigo_postal: '', pais: '' };
  }
  const e = endereco as Record<string, unknown>;
  return {
    rua: (e.rua as string) || '',
    numero: (e.numero as string) || '',
    complemento: (e.complemento as string) || '',
    cidade: (e.cidade as string) || '',
    codigo_postal: (e.codigo_postal as string) || '',
    pais: (e.pais as string) || '',
  };
}
